import PartnerDomainsFilters from "./PartnerDomainsFilters";

export default PartnerDomainsFilters;


// WEBPACK FOOTER //
// ./src/scenes/PartnerDomains/components/PartnerDomainsFilters/index.js